import { useQuery } from "@tanstack/react-query";
import { CoachService } from "../services";
import { useSocialCoachSession } from "./useSocialCoachSession";

export const useIndustryRoles = () => {
  const { coachId, playerId } = useSocialCoachSession();

  return useQuery({
    queryKey: ["industryRoles", coachId, playerId],
    queryFn: () => CoachService.playerIndustryRoles(coachId!, playerId!),
    enabled: !!coachId && !!playerId,
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 24, // 24 hours
  });
};
